import { Typography } from '@navi/web-ui/lib/primitives';
import { useParams } from 'react-router-dom';
import styles from './index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import FilterDrawer from '@cp/src/components/FilterDrawer';
import NotificationIcon from '@cp/src/assets/icons/NotificationIcon';
import { useState } from 'react';
import { NotificationLink } from '@cp/src/components/NotificationsLink';
import { RootState } from '@cp/src/store';
import { AnomalyStatus, AnomalyTableKeys, TabsKey } from '../../types';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { getAnomalyTickets } from '../../actions/AnomalyTrackerAction';

const Header = () => {
  const { tabId = '' } = useParams();
  const dispatch = useDispatch();
  const anomalyOpenFilterSchema = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyOpenFilterSchema
  );
  const anomalyClosedFilterSchema = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyClosedFilterSchema
  );
  const [showNotifications, setShowNotifications] = useState(false);

  const toggleNotifications = (show: boolean) => {
    setShowNotifications(show);
  };

  const notificationHandler = () => {
    setShowNotifications(!showNotifications);
  };

  const applyFiltersHandler = () => {
    const queryParams = readQueryParams();
    const isOpenAnomalyView = tabId === TabsKey.OPEN_ANOMALY;

    const params =
      queryParams[
        isOpenAnomalyView
          ? AnomalyTableKeys.OPEN_ANOMALY_TABLE
          : AnomalyTableKeys.CLOSED_ANOMALY_TABLE
      ];
    const defaultParams = {
      ...params,
      pageSize: params?.pageSize || 10,
      pageNo: params?.pageIndex || 0
    };
    delete defaultParams.pageIndex;
    dispatch(
      getAnomalyTickets(
        isOpenAnomalyView ? AnomalyStatus.OPEN : AnomalyStatus.CLOSED,
        defaultParams
      )
    );
  };

  const getFilterSchema = () => {
    return tabId === AnomalyStatus.OPEN ? anomalyOpenFilterSchema : anomalyClosedFilterSchema;
  };

  return (
    <div className={styles.header}>
      <div className={styles.headerTitle}>
        <Typography variant="h3">Anomaly Tracker</Typography>
        <div className={styles.filtersContainer}>
          <FilterDrawer
            filterSchema={getFilterSchema()}
            filterButtonTitle="Filters"
            drawerContainerClass="!w-[360]"
            selectedFiltersClass="!p-0"
            onApply={applyFiltersHandler}
            tableName={tabId}
            queryParamTableIdentifier={
              tabId === AnomalyStatus.OPEN
                ? AnomalyTableKeys.OPEN_ANOMALY_TABLE
                : AnomalyTableKeys.CLOSED_ANOMALY_TABLE
            }
            defaultParams={{ pageSize: '10', pageIndex: '0' }}
          />
          <div className={styles.notif} onClick={notificationHandler}>
            <NotificationIcon />
          </div>
        </div>
      </div>
      <NotificationLink
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
        notificationCountClass="!top-4 !right-[44px]"
      />
    </div>
  );
};

export default Header;
